// extracted by mini-css-extract-plugin
module.exports = {"authButtonsContainer":"auth-buttons_authButtonsContainer__Kx1Zv","authButton":"auth-buttons_authButton__sqyx5"};